<template>
    <div>
        <el-dialog title="修改用户名" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-save-name">
        <img src="../assets/images/tuoyuan.png" alt="背景图" class="dialog-img">
        <img src="../assets/images/close.png" alt="关闭" @click="cancelSaveUserNameHandler">
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" :label-width="formLabelWidth">
            <el-form-item label="用户名：" prop="user_name">
                <el-input v-model="ruleForm.user_name" autocomplete="off" placeholder="请输入用户名">
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <div>
                <el-button @click="cancelSaveUserNameHandler" class="vip-btn1">取消</el-button>
                <el-button @click="saveUserNameHandler" class="vip-btn2">保存</el-button>
            </div>
        </div>
        </el-dialog>
    </div>
</template>

<script>
import { saveUserName } from '@/api/home'
export default {
    name: "UpdateUserName",
    data() {
        const validateUserName = (rule, value, callback) => {
            if (value.length === 0) {
                callback(new Error("请输入用户名"));
            } else {
                if ((/^[0-9a-zA-Z]*$/g.test(value))) {
                    callback();
                } else {
                    callback(new Error("用户名必须是字母、数字组合"));
                }
            }
		};
        return {
            ruleForm: {
                user_name: ''
            },
            showSuccess: false,
            detail_id: '',
            rules: {
                user_name: [
                    {trigger: 'blur', validator: validateUserName }
                ],
            },
            formLabelWidth:'80px',
        };
    },
    methods: {
        cancelSaveUserNameHandler() {
            this.$store.commit('user/SHOWSAVEUSERNAME', false);
        },
        saveUserNameHandler() {
            let _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    saveUserName(this.ruleForm).then(res => {
                        this.$message({
                            message: '修改用户名成功',
                            type: 'success'
                        })
                        this.$store.commit('user/SHOWSAVEUSERNAME', false);
                        this.$store.commit('user/SAVEUSERNAMESUC', true);
                    })
                }
            })
        },
        closeHandler() {
            this.$store.commit('user/SHOWSAVEUSERNAME', false);
        },
    }
}
</script>

<style lang='scss' scoped>
.dialog-box {
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    p {
        margin: 40px 0;
        color: #5e6166;
        font-size: 16px;
        position: relative;
        z-index: 9999;
        text-align: left;
        margin: 0;
        line-height: 30px;
    }
    .dialog-footer {
        padding: 0;
        button {
            width: 240px;
            height: 52px;
            border-radius: 8px;
            font-size: 18px!important;
            border: none;
            margin-bottom: 30px;
        }
        .vip-btn1 {
            background: #e1e4eb!important;
            color: #5e6166!important;
            background: #e1e4eb!important;
            position: relative;
            left: -10px;
        }
        .vip-btn2 {
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            color: #ffffff!important;
            position: relative;
            right: -10px;
        }
        .dialog-p {
            font-weight: 600;
        }
    }
}
.dialog-save-plan-after {
    .dialog-img-success {
        width: 104px;
        height: 111px;
        position: relative;
        top: auto;
        right: auto;
        left: 50%;
        top: -20px;
        transform: translateX(-50%);
    }
    h3 {
        font-size: 22px;
        font-weight: 400;
        text-align: center;
        margin: 0; 
        color: #2c2e33;
        line-height: 30px;
        margin-bottom: 36px;
    }
}
</style>